(function () {
  'use strict';

  angular
    .module('crewValidation')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewValidation', {
        url: '/crew-validation',
        views: {
            'crewValidationView': {
            	templateUrl: 'crew-validation/views/crew-validation.tpl.html',
                controller: 'CrewValidationCtrl',
                controllerAs: 'crewValidation'
            }
        }
        
      });
  }  
   
}());
